
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1407Dialog extends Serenity.EntityDialog<Report_1407Row, any> {
        protected getFormKey() { return Report_1407Form.formKey; }
        protected getIdProperty() { return Report_1407Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1407Row.localTextPrefix; }
        protected getNameProperty() { return Report_1407Row.nameProperty; }
        protected getService() { return Report_1407Service.baseUrl; }
        protected getDeletePermission() { return Report_1407Row.deletePermission; }
        protected getInsertPermission() { return Report_1407Row.insertPermission; }
        protected getUpdatePermission() { return Report_1407Row.updatePermission; }

        protected form = new Report_1407Form(this.idPrefix);

    }
}